import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2/dist/sweetalert2.js';
import { BaseComponent } from '../base/base.component';
import { Student } from '../data/student';
import { FormatUtilities } from '../utilities/format-utilities';
import { AssignStudentToParentModalComponent } from '../assign-student-to-parent-modal/assign-student-to-parent-modal.component';
import { Course } from '../data/course';
import { tap } from 'rxjs/operators';
import { AuthService } from '../auth.service';


@Component({
  selector: 'app-student-detail',
  templateUrl: './student-detail.component.html',
  styleUrls: ['./student-detail.component.scss']
})
export class StudentDetailComponent extends BaseComponent implements OnInit {

  classSectionId: number;
  classId: number;
  className: string;
  defaultCourseCode: string;
  studentId: number;
  resettingPasscode = false;
  student: Student;
  currentMaxReachedInReport: number = 0;
  miniSize = 'mini';
  pageName: string = 'progress';
  courses: Course[];
  isParent: boolean;

  get studentGradeLevelOptions() {
    return Student.gradeLevelOptions;
  }

  getGradeLevelString(gradeLevel: string) {
    return Student.getGradeLevelString(gradeLevel);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(qp => this.defaultCourseCode = qp.courseCode);
    this.route.params.subscribe(params => {
      this.classSectionId = +params.organizationId;
      this.classId = +params.classId;
      this.studentId = +params.studentId;
      this.student = null;
      this.getStudent();
      if (this.classSectionId && this.classId) {
        this.dataService.getClass(this.classId).subscribe(c => {
          this.className = c.Description;
        });
      }
      else {
        this.dataService.getCurrentClassForStudent(this.studentId).subscribe(c => {
          this.className = c.Description;
          this.classId = c.ID;
          this.classSectionId = c.ClassSectionID;
        })
      }
    });
    this.dataService.getCourses().subscribe(result => {
      this.courses = Course.Sort(result);
    });
    this.isParent = this.authService.isParent();
  }

  setPage(page: string): void {
    this.pageName = page;
  }

  deleteStudent(): void {
    this.dataService.promptDelete('This will permanently delete the student: ' + this.student.Name + '.')
      .then(() => {
        this.deleteObj = this.student;
        this.dataService.deleteStudent(this.student.ID).subscribe(() => {
          this.goBack();
        });
      });
  }

  findLast<T>(array: T[], predicate: (item: T) => boolean): T {
    for (var i = array.length - 1; i >= 0; --i) {
      if (predicate(array[i]))
        return array[i];
    }
    return null;
  }

  getStudent(): void {
    this.dataService.getStudent(this.studentId, this.classId).subscribe(o => this.student = o);
  }

  resetPasscode(): void {
    swal.fire({
      title: 'Are you sure?',
      text: "This will reset the student's passcode.",
      type: 'warning',
      confirmButtonText: 'Reset',
      showConfirmButton: true,
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        confirmButton: 'swal-button--danger',
      }
    })
      .then(res => {
        if (res.value) {
          this.resettingPasscode = true;
          this.student.PassCode = '';
          this.dataService.updateStudent(this.student)
            .subscribe(student => {
              if (student) {
                this.editObj = null;
                this.student = student;
                swal.fire('Success', 'Passcode reset.', 'success');
              }
              this.resettingPasscode = false;
            });
        }
      });
  }

  removeParent(parentId: number): void {
    swal.fire({
      title: 'Are you sure?',
      text: "This will remove the parent from the student",
      type: 'warning',
      confirmButtonText: 'Confirm',
      showConfirmButton: true,
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        confirmButton: 'swal-button--danger',
      }
    }).then(res => {
      if (res.value) this.dataService.removeParentFromStudent(parentId, this.student.ID).subscribe(response => {
        this.getStudent();
      });
    })
  }

  updateStudent(): void {
    this.startSaveObj(event);
    this.dataService.updateStudent(this.student).subscribe(student => {
      if (student) {
        this.handleSaveSuccess();
      }
      else {
        this.handleSaveError();
      }
    });
  }

  getDefaultCourseCode(): string {
    return this.student.ReassignmentCourse || this.student.CurrentCourse || "PlacementTest";
  }
}
